import Eclipsef from './p1.jpg';
import Eclipses from './p2.jpg';
import Eclipseth from './p3.jpg';
import Eclipsesfth from './p4.jpg';

let photos = [
    {
        src: Eclipsef,
        width: 2,
        height: 1.5
    },
    {
        src: Eclipses,
        width: 2,
        height: 1.5
    },

    {
        src: Eclipseth,
        width: 2,
        height: 1.5
    },
    {
        src: Eclipsesfth,
        width: 2,
        height: 1.5
    }
];

export default photos;